import { StorageEvents } from '@app/hooks'
import { User } from '@app/models'

export const SyncCurrentUserStorage = (payload: User) => {
  localStorage.setItem(StorageEvents.CURRENT_USER, JSON.stringify(payload))
}
